import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountIdByWorkspaceQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type GetAccountIdByWorkspaceQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string } | null };


export const GetAccountIdByWorkspace = /*#__PURE__*/ gql`
    query GetAccountIdByWorkspace($workspaceId: ID!) {
  account(by: {workspaceId: $workspaceId}) {
    id
  }
}
    ` as unknown as DocumentNode<GetAccountIdByWorkspaceQuery, GetAccountIdByWorkspaceQueryVariables>;

          

          export const useGetAccountIdByWorkspaceQuery = (options?:QueryHookOptions<GetAccountIdByWorkspaceQuery, GetAccountIdByWorkspaceQueryVariables>) => useQuery(GetAccountIdByWorkspace, options);

          

          export type GetAccountIdByWorkspaceQueryOptions = QueryHookOptions<GetAccountIdByWorkspaceQuery, GetAccountIdByWorkspaceQueryVariables>;

          

          export const useGetAccountIdByWorkspaceLazyQuery = (options?:LazyQueryHookOptions<GetAccountIdByWorkspaceQuery, GetAccountIdByWorkspaceQueryVariables>) => useLazyQuery(GetAccountIdByWorkspace, options);

          

          export type GetAccountIdByWorkspaceQueryResult = ReturnType<typeof useGetAccountIdByWorkspaceQuery>;

          
